module.exports = __webpack_public_path__ + "static/media/fractal_logo.ab241f33.svg";